<template>
  <div class="mb-3 employee-compliance-item">
    <div class="card border-0">
      <div class="card-body p-3">
        <div class="d-flex align-items-start justify-content-between">
          <div class="d-flex w-100 justify-content-between">
            <div class="d-flex align-items-center mb-1">
              <div class="mr-2">
                <user-avatar :avatarURL="staff.avatar_src"></user-avatar>
              </div>
              <div class="staff-name-text">
                <div class="d-flex align-items-center">
                  <div class="card-name">
                    {{ staff.display_name || staff.name }}
                  </div>
                  <!-- <small class="card-group-name">{{ staff.group_name }}</small> -->
                </div>
                <div class="card-desc">
                  {{ staff.designation }}
                </div>
              </div>
            </div>
            <a class="border-0 p-0 ml-1" :href="mailToUrl">
              <i class="fas fa-envelope mail-icon" style="color: black"></i>
            </a>
          </div>
        </div>
        <div v-if="ready">
          <div
              v-if="data.length !== 0"
              class="
            d-flex
            align-items-center
            justify-content-between
            mt-2
            card-bottom
          "
          >
            <div class="text-compliance-point d-flex align-items-center"></div>
            <div class="card-dropdown">
              <span>View Details</span>
              <button
                  @click="toggleCard"
                  ref="task-log"
                  class="btn btn-link bg-white border-0 ml-1"
                  style="line-height: 1.4; padding: 0.3em 0.6em !important"
                  data-toggle="collapse"
                  :data-target="`#taskLog-${staff.id}`"
                  aria-expanded="false"
                  :aria-controls="`taskLog-${staff.id}`"
              >
                <i
                    class="fas fa-chevron-down"
                    style="color: black"
                    :class="{
                  'fa-chevron-down': !expand,
                  'fa-chevron-up': expand,
                }"
                ></i>
              </button>
            </div>
          </div>
          <div v-else>
            Employee has no data
          </div>
        </div>
      </div>
    </div>
    <div class="collapse" :id="`taskLog-${staff.id}`">
      <div class="card card-body border-0 py-2 px-4" v-for="(item, date) of data">
        <h6 class="h6 font-weight-bold">{{date}}</h6>

        <div
            @click="showSelfieImage(item.selfie_image_src)"
            :style="`cursor: ${item.selfie_image_src ? 'pointer' : 'default'};`"
            v-if="hasSelfieCheckin"
        >
          <img
              :src="checkedIcon(item.selfie_image_src)"
              class="mr-2 rounded-circle"
              alt="check"
          />
          <span class="completed-text">
          Selfie Check In
            <img
                src="/images/selfie_placeholder.svg"
                class="mr-2 rounded-circle"
                alt="check"
                v-if="item.selfie_image_src"
            />
          </span>
          <span class="completed-time float-right ml-3">{{
              formatCompletedAt(item.last_checked_in_at)
            }}</span>
        </div>
        <div>
          <img
              :src="
            calculateWorkHours(item, date) / 60 >= 8
              ? '/images/Icon-check-green.svg'
              : '/images/icon-check-gray.svg'
          "
              class="mr-2 rounded-circle"
              alt="check"
          />
          Worked for 8 hours
        </div>
        <div v-for="task in getTaskByDate(date)" :key="task.id">
          <img
              src="/images/Icon-check-green.svg"
              alt="check"
              class="mr-2 rounded-circle"
          />
          <span class="completed-text">{{ task.title }}</span>
          <span class="completed-time float-right ml-3">{{
              formatCompletedAt(task.completed_at)
            }}</span>
          <span>{{ task.completed_at | fromNow }}</span>
        </div>

        <div>
          <img
              :src="checkedIcon(item.checked_out_at)"
              class="mr-2 rounded-circle"
              alt="check"
          />
          <span class="completed-text">
          Checked-Out
        </span>
          <span class="completed-time float-right ml-3">{{
              formatCompletedAt(item.checked_out_at)
            }}</span>
        </div>
      </div>
    </div>
    <div class="modal-mask" v-if="showModal">
      <div class="modal-wrapper">
        <div class="edit-user-card p-0">
          <button
            type="button"
            @click="showModal = false"
            class="modal-close-btn"
          >
            X
          </button>

          <div class="p-4">
            <p class="modal-heading">{{ staff.name }} Selfie</p>
          </div>
          <img
            :src="selfie_image_src"
            style="max-width: 100%; max-height: 100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: ['staff', 'date', 'timezone'],
  data() {
    return {
      ready: false,
      tasks: [],
      workMinutes: 0,
      last: null,
      totalTask: 0,
      lastCheckedIn: null,
      checkedOut: null,
      expand: false,
      selfie_image_src: null,
      showModal: false,
      data: [],
    }
  },
  mounted() {
    this.fetchTasks()
    this.fetchWorkMinutes()
  },
  filters: {
    fromNow(date) {
      return moment(new Date(date)).fromNow()
    },
  },
  methods: {
    toggleCard: _.debounce(async function () {
      this.expand = !this.expand
    }, 200),

    async fetchTasks() {
      const res = await axios.get(`/tasks?status=completed`, { params: {
          user_id: this.staff.id,
          completed_range: [
            moment(this.date.start).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            moment(this.date).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          ]
      }})

      this.tasks = res.data.data
      this.totalTask = res.data.total
    },
    async fetchWorkMinutes() {
      const res = await axios.get(`/staff-compliance`, { params: {
          user: this.staff.id,
          start_date: this.date.start,
          end_date: this.date.end,
        }});

      this.data = res.data?.data;
      this.ready = true;
    },
    formatCompletedAt(time) {
      return time ?
        this.timezone
          ? moment.utc(time).tz(this.timezone).format('h:mm A')
          : moment.utc(time).local().format('h:mm A')
        : ''
    },

    checkedIcon(item) {
      return item
        ? '/images/Icon-check-green.svg'
        : '/images/icon-check-gray.svg'
    },

    getTaskByDate(date) {
      return this.tasks.filter((item) => moment(item.completed_at).isSame(moment(date), 'date'));
    },

    calculateWorkHours (data, date) {
      let minutes = data.work_minutes;
      if (!data.last_checked_in_at) return minutes;
      const lastCheckInMomentTime = this.timezone
          ? moment.utc(data.last_checked_in_at).tz(this.timezone)
          : moment.utc(data.last_checked_in_at).local()
      const nowMomentTime = this.timezone
          ? moment.utc().tz(this.timezone)
          : moment.utc().local()
      const filterDateMomentTime = date
          ? this.timezone
              ? moment.utc(date).tz(this.timezone)
              : moment.utc(date).local()
          : nowMomentTime
      const checkedOutMomentTime = data.checked_out_at
          ? this.timezone
              ? moment.utc(data.checked_out_at).tz(this.timezone)
              : moment.utc(data.checked_out_at).local()
          : nowMomentTime
      if (filterDateMomentTime.isSame(nowMomentTime, 'day')) {
        // if filter is today
        if (lastCheckInMomentTime.isSame(filterDateMomentTime, 'day')) {
          // if last checkin same day with filter
          minutes += nowMomentTime.diff(
              lastCheckInMomentTime,
              'minute',
          )
        } else {
          // if last checkin same NOT day with filter
          const todayStartMomentTime = nowMomentTime.clone().startOf('day')
          minutes = nowMomentTime.diff(
              todayStartMomentTime,
              'minute',
          )
        }
      } else {
        // if filter is not today
        if (lastCheckInMomentTime.isSame(filterDateMomentTime, 'day')) {
          // if checked out time is in the same day of filter, check last checkout time
          if(checkedOutMomentTime.isSame(filterDateMomentTime, 'day')) {
            minutes += checkedOutMomentTime.diff(
                lastCheckInMomentTime,
                'minute',
            )
          } else { // if last checkin same day with filter
            const dayEndMomentTime = lastCheckInMomentTime.clone().endOf('day')
            minutes += dayEndMomentTime.diff(
                lastCheckInMomentTime,
                'minute',
            )
          }
        } else {
          // if last checkin same NOT day with filter
          minutes = 24 * 60
        }
      }
      return minutes
    },

    showSelfieImage(selfieImage) {
      if (selfieImage) {
        this.selfie_image_src = selfieImage;
        this.showModal = true;
      }
    },
  },
  computed: {
    mailToUrl() {
      return `mailto:${this.staff.email}`
    },
    showLog() {
      return this.$refs['task-log']
        ? !!this.$refs['task-log'].attrs('aria-expanded')
        : false
    },

    currentUser() {
      return this.$store.state.currentUser
    },

    hasSelfieCheckin() {
      return this.currentUser?.company?.photo_checkin ?? false
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/core/mixins";

.employee-compliance-item {
  border-bottom: 1px solid #dce2ed;

  .card {
    .card-name {
      color: #303030;
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 22px;
    }

    .card-desc {
      color: #7d8fa6;
      font-family: "Open Sans";
      font-size: 10px;
      letter-spacing: 0;
      line-height: 22px;
    }

    .card-bottom {
      margin-left: 42px;
    }

    .card-dropdown {
      border: 1px solid #dce2ed;
      border-radius: 4px;
      background-color: #fff;
      padding-left: 12px;
      color: #808fa4;
    }
  }

  .btn-envelope {
    background: #000;
  }

  .completed-text {
    color: #303030;
    font-family: "Open Sans";
    font-size: 14px;
    letter-spacing: 0;
    line-height: 22px;
  }

  .completed-time {
    color: #8997aa;
    font-family: "Open Sans";
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 14px;
    text-align: right;
  }

  .text-compliance-point {
    color: #303030;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;
  }
}

.staff-name-text {
  line-height: 1.25;
}

.mail-icon {
  font-size: 1.2rem;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-heading {
  color: #333;
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 27px;
  margin: 0;
}
</style>
